import React, { useCallback, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { accuseRecomment } from "redux/modules/postSlice";

import { Accused } from "../MoreComponent";

import { DetailLine } from "../common/commonStyle";
import {
  Container,
  CreateHead,
  ArrowBack,
  AccusedContent,
  Registration,
} from "./AccuseStyle";

function AccuseRecomment() {
  const navigate = useNavigate();
  const { recommentId } = useParams();
  const dispatch = useDispatch();

  //   const post = location.state.post;
  const [isAccusedRecomment, setIsAccusedRecomment] = useState(false);
  const [select, setSelect] = useState("");

  const reasonsArray = useMemo(() => {
    return [
      { 1: "신고사유 1" },
      { 2: "신고사유 2" },
      { 3: "신고사유 3" },
      { 4: "신고사유 4" },
      { 5: "신고사유 5" },
      { 6: "신고사유 6" },
    ];
  }, []);

  // 신고버튼 클릭
  const onClickRegister = useCallback(() => {
    const contentArr = reasonsArray.filter((v, i) => v[`${i + 1}`] === select);
    const selectNumber = Object.keys(contentArr[0])[0];

    const payload = { recommentId: recommentId, content: selectNumber };
    dispatch(accuseRecomment(payload));
    setIsAccusedRecomment(true);
    setTimeout(() => {
      setIsAccusedRecomment(false);
      navigate(-1);
    }, 700);
  }, [dispatch, navigate, recommentId, select, reasonsArray]);

  const onClickReason = useCallback((e) => {
    setSelect(e.target.innerHTML);
  }, []);
  const onClickReasonImg = useCallback((e) => {
    setSelect(e.target.id);
  }, []);

  return (
    <Container>
      <CreateHead>
        <ArrowBack
          onClick={() => navigate(-1)}
          src="/img/arrowBack.svg"
          alt="arrow back"
        />
        <h1>신고하기</h1>
      </CreateHead>
      <DetailLine />
      <AccusedContent>
        <fieldset>
          <legend>
            커뮤니티에 부적절한 답글 인가요? <br />
            신고 이유를 선택해 주세요
          </legend>
          {reasonsArray.map((reason, i) => (
            <>
              <div key={reason[`${i + 1}`]} className="selectItems">
                <div
                  id={reason[`${i + 1}`]}
                  className={
                    reason[`${i + 1}`] === select ? "selected-circle" : "circle"
                  }
                  onClick={onClickReasonImg}
                ></div>
                <div className="reasonText" onClick={onClickReason}>
                  {reason[`${i + 1}`]}
                </div>
              </div>
            </>
          ))}
        </fieldset>
      </AccusedContent>

      <Registration>
        {/* 사유 선택여부 */}
        {select !== "" ? (
          <div className="possible" onClick={onClickRegister}>
            <div>신고하기</div>
          </div>
        ) : (
          <div className="impossible">
            <div>신고하기</div>
          </div>
        )}
      </Registration>

      {isAccusedRecomment && <Accused />}
    </Container>
  );
}

export default AccuseRecomment;
